import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

// TS port of the source (Falah) app's pages/reports/revenue/RevenueByCategoryReport.jsx.
const COLUMNS: ReportColumn[] = [
  { key: 'type', label: 'Type' },
  { key: 'category', label: 'Category' },
  { key: 'count', label: 'Receipts', align: 'right' },
  { key: 'total', label: 'Total', align: 'right', type: 'money' },
];

export function RevenueByCategoryReport() {
  return (
    <ReportView
      title="Revenue by Category"
      description="Collected revenue totals grouped by type and category."
      endpoint="/reports/revenue/by-category"
      columns={COLUMNS}
      filters={['dateRange']}
    />
  );
}
